module.exports = __webpack_public_path__ + "img/visa.9f902fd8.png";